var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 17,
    viewBox: "0 0 25 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 8.4375C7.5 5.84867 9.59867 3.75 12.1875 3.75C14.7763 3.75 16.875 5.84867 16.875 8.4375C16.875 11.0263 14.7763 13.125 12.1875 13.125C9.59867 13.125 7.5 11.0263 7.5 8.4375ZM12.1875 5.625C10.6342 5.625 9.375 6.8842 9.375 8.4375C9.375 9.9908 10.6342 11.25 12.1875 11.25C13.7408 11.25 15 9.9908 15 8.4375C15 6.8842 13.7408 5.625 12.1875 5.625Z",
    fill: "#969696"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.59178 6.74544C2.06789 7.50036 1.875 8.09087 1.875 8.4375C1.875 8.78413 2.06789 9.37464 2.59178 10.1296C3.09821 10.8593 3.85097 11.6504 4.80334 12.3813C6.71223 13.8463 9.32932 15 12.1875 15C15.0457 15 17.6628 13.8463 19.5717 12.3813C20.524 11.6504 21.2768 10.8593 21.7832 10.1296C22.3071 9.37464 22.5 8.78413 22.5 8.4375C22.5 8.09087 22.3071 7.50036 21.7832 6.74544C21.2768 6.01569 20.524 5.22465 19.5717 4.49371C17.6628 3.02865 15.0457 1.875 12.1875 1.875C9.32932 1.875 6.71223 3.02865 4.80334 4.49371C3.85097 5.22465 3.09821 6.01569 2.59178 6.74544ZM3.66176 3.00629C5.82457 1.34635 8.83248 0 12.1875 0C15.5425 0 18.5504 1.34635 20.7132 3.00629C21.7967 3.83785 22.6915 4.76556 23.3236 5.67643C23.9383 6.56214 24.375 7.53413 24.375 8.4375C24.375 9.34087 23.9383 10.3129 23.3236 11.1986C22.6915 12.1094 21.7967 13.0371 20.7132 13.8687C18.5504 15.5287 15.5425 16.875 12.1875 16.875C8.83248 16.875 5.82457 15.5287 3.66176 13.8687C2.57828 13.0371 1.68351 12.1094 1.05138 11.1986C0.436714 10.3129 0 9.34087 0 8.4375C0 7.53413 0.436714 6.56214 1.05138 5.67643C1.68351 4.76556 2.57828 3.83785 3.66176 3.00629Z",
    fill: "#969696"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/Eye.7bed4fb4a3c43a719753ae8a46ddc77c.svg";
export { ForwardRef as ReactComponent };